import { env } from "env";

export const environment = {
  production: false,
  env
};
